import { useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  progressInput: {
    display: "flex",
    margin: "8px 0",
    "& > *": {
      margin: "auto 0",
    },
    "& > svg": {
      color: "rgba(0, 0, 0, 0.5)",
      "&:hover": {
        color: "initial",
        cursor: "pointer",
      },
    },
  },
  settingsContainer: {
    border: "1px solid #e1e1e1",
    borderRadius: 5,
    padding: 5,
    paddingTop: 10,
    position: "relative",
  },
  stepLabel: {
    aspectRatio: 1,
    background: "#00c875",
    borderRadius: "50%",
    color: "#fff",
    fontWeight: 600,
    height: "25px",
    lineHeight: "25px",
    margin: "auto 4px auto 0",
    pointerEvents: "none",
    textAlign: "center",
  },
  textLabel: {
    background: "#fff",
    fontSize: 12,
    color: "#bdb4b4",
    position: "absolute",
    left: 15,
    top: -9,
    minWidth: 80,
    textAlign: "center",
  },
}));

const getSettingsFromLayout = layout => ({});

const ProgressInput = ({ index, onAdd, onChange, onDelete, value }) => {
  const classes = useStyles();
  const inputRef = useRef(null);

  const handleAdd = () => {
    const value = inputRef.current.value.trim();
    if (value.length > 0) {
      onAdd?.(value);
      inputRef.current.value = "";
    }
  };

  const handleKeyDown = (e) => {
    if (onAdd && e.key === "Enter") {
      handleAdd();
    }
  };

  return (
    <Box className={classes.progressInput}>
      <Typography component="div" className={classes.stepLabel}>
        {onDelete && (index + 1)}
      </Typography>
      <TextField
        inputRef={inputRef}
        onChange={(e) => onChange?.(index, e.target.value)}
        onKeyDown={handleKeyDown}
        size="small"
        value={value}
      />
      {onAdd &&
        <IconButton onClick={handleAdd}>
          <AddCircleOutlineIcon />
        </IconButton>
      }
      {onDelete &&
        <IconButton onClick={() => onDelete?.(index)}>
          <DeleteOutlineIcon />
        </IconButton>
      }
    </Box>
  );
};

const phasesReducer = (state, action, payload) => {
  const { index, value } = payload;
  switch (action) {
    case "add":
      return [...state, value];

    case "delete":
      var updated = [...state];
      updated.splice(index, 1);
      return updated;

    case "update":
      var updated = [...state];
      updated.splice(index, 1, value);
      return updated;

    default:
      return state;
  }
};

const ProjectProgressSettings = ({ onWidgetPropertyUpdate, projectId, selectedWidget }) => {
  const classes = useStyles();

  const settings = getSettingsFromLayout(selectedWidget);

  const [phases, setPhases] = useState(["Uppstart", "Implementation", "Information", "Utbildning", "Uppföljning"]);

  const updatePhases = (action, payload) => setPhases(prev => phasesReducer(prev, action, payload));

  return (
    <Box className={classes.settingsContainer}>
      <Typography className={classes.textLabel}>
        <FormattedMessage id="Projektfaser" />
      </Typography>
      {
        phases.map((value, index) =>
          <ProgressInput
            key={index}
            index={index}
            value={value}
            onChange={(index, value) => updatePhases("update", { index, value })}
            onDelete={(index) => updatePhases("delete", { index })}
          />)
      }
      <ProgressInput onAdd={(value) => updatePhases("add", { value })} />
    </Box>
  );
};

export default ProjectProgressSettings;
